import React from 'react';
import './IndexMappingsEditorModalHelp.scss';
import { HelpPortal } from 'utils/components/helpPortal/HelpPortal';

export function IndexMappingsEditorModalHelp() {
    return (
        <HelpPortal
            className="IndexMappingsEditorModalHelp"
            width={400}
            height={260}
            left={-380}
        >
            <div>
                Use this dialog to configure your symbol to index mappings, for
                use in the Performance vs Index Capsule.
            </div>
            <div>
                The mappings configured here are saved in your Indigo user
                preferences, and will apply across all of your layouts.
            </div>
            <div>
                Click the &quot;Add&quot; button to add a new mapping. Select an
                attribute from the dropdown, and the comparison value. In the
                index column set the index that will be used if the rule passes.
            </div>
            <div>
                Widgets/capsules will use the first mapping that passes for the
                selected symbol. Use the arrow buttons to adjust the order in
                which the rules will be evaluated.
            </div>
            <div>
                If no mappings pass, the default local index will be used.
            </div>
        </HelpPortal>
    );
}
